module.exports = __webpack_public_path__ + "f9cbd8a7132af2cf208c1c6ff96c0392.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/dripicons/dripicons.woff
 ** module id = ./src/styles/fonts/dripicons/dripicons.woff
 ** module chunks = 0
 **/